import { inputBlurValidation } from "../../Validations/inputValidation";

export function ButtonDisplay(
  primaryAdvisor,
  primaryErrors,
  secondaryActive,
  secondaryAdvisor,
  secondaryErrors
) {
  let userform = true;
  let emailError = true;
  let emailError2 = true;
  let addressError = true;
  let addressError2 = true;
  let phoneError = true;
  let phoneError2 = true;
  let emailValError = true;
  let emailValError2 = true;
  let cityValError = false;
  let cityValError2 = false;
  let stateValError = false;
  let stateValError2 = false;
  let zipcodeValError = false;
  let zipcodeValError2 = false;
  let ssnValError2 = false;
  let cnfssnValError2 = false;
  let secondaryUserFormError = false;
  let relatedDonorError = false;

  let {
    firstname,
    deliveryMethod,
    dob,
    lastname,
    ssn
  } = primaryAdvisor;
  //Checking for userform fields
  if (
    firstname != null &&
    lastname != null &&
    deliveryMethod != null &&
    dob != null &&
    ssn != null
  ) {
    userform = false;
  }
  //checking for related donor
  let counterRD = 0;
  if(primaryAdvisor.relatedDonor && primaryAdvisor.relatedDonor.length != 0) {
    primaryAdvisor.relatedDonor.forEach(val => {
      if((val.name && !val.name.trim()) || (val.relationship && !val.relationship)){
        counterRD++;
      }
    });

    if(counterRD != 0){
      relatedDonorError = true;
    }else{
      relatedDonorError = false;
    }

  }

  function checkEmail(email){
    if(email.emailtype === undefined || email.emailtype === null || email.emailtype === ""){
      return true;
    }
    return false;
  }
  //Checking for primary Advisor fields
  if (primaryAdvisor.emails && primaryAdvisor.emails.length > 0) {
    emailError = primaryAdvisor.emails.map(email => {
      if (checkEmail(email) ) {
        return true;
      } else {
        if(email.emailId === "" && email.emailtype === "Primary"){
          return true;
        } else {
          return false;
        }
      } 
    });

    emailValError = primaryAdvisor.emails.map(email => {
      if (email.emailId && inputBlurValidation(email.emailId, "emailId") === false) 
      return true;
      else return false;
    });
  }
  if (primaryAdvisor.addresses && primaryAdvisor.addresses.length > 0) {
    addressError = primaryAdvisor.addresses.map(address => {
      if (
        !address.addresstype ||
        !address.city ||
        address.country === null ||
        address.country === "" ||
        !address.line1 ||
        address.line1.trim() === "" ||
        !address.state ||
        address.state.trim() === "" ||
        !address.zipcode ||
        address.zipcode.trim() === ""
      ){
        return true;
      }else{
        return false;
      }
    });
  }

  function checkPhone(phone){
    if(phone.phonetype === undefined || phone.phonetype === null || phone.phonetype === ""){
      return true;
    }
    return false;
  }
  if (primaryAdvisor.phones && primaryAdvisor.phones.length > 0) {
    phoneError = primaryAdvisor.phones.map(phone => {
      if (checkPhone(phone)){
        return true;
      } else {
        if(phone.phonenumber.trim() === "" && phone.phonetype === "Primary"){
          return true;
        } else {
          return false;
        }
      } 
      
    });
  }
  //Checking Primary advisor Error fields
  if (primaryErrors) {
    if (
      Object.prototype.hasOwnProperty.call(primaryErrors, "city") &&
      Object.keys(primaryErrors.city).length > 0
    ) {
      let cityError = primaryErrors.city;
      for (let [key, value] of Object.entries(cityError))
        if (value != null) cityValError = true;
    }
    if (
      Object.prototype.hasOwnProperty.call(primaryErrors, "state") &&
      Object.keys(primaryErrors.state).length > 0
    ) {
      let stateError = primaryErrors.state;
      for (let [key, value] of Object.entries(stateError))
        if (value != null) stateValError = true;
    }
    if (
      Object.prototype.hasOwnProperty.call(primaryErrors, "zipcode") &&
      Object.keys(primaryErrors.zipcode).length > 0
    ) {
      let zipcodeError = primaryErrors.zipcode;
      for (let [key, value] of Object.entries(zipcodeError))
        if (value != null) zipcodeValError = true;
    }
  }

  //Checking for secondary Advisor fields
  if (secondaryActive) {

    if (secondaryAdvisor.emails && secondaryAdvisor.emails.length > 0) {
      emailError2 = secondaryAdvisor.emails.map(email => {
        if (checkEmail(email) ) {
          return true;
        } else {
          if(email.emailId === "" && email.emailtype === "Primary"){
            return true;
          } else {
            return false;
          }
        }
      });

      emailValError2 = secondaryAdvisor.emails.map(email => {
        if (email.emailId && inputBlurValidation(email.emailId, "emailId") === false) 
        return true;
        else return false;
      });
    }
    if (secondaryAdvisor.addresses && secondaryAdvisor.addresses.length > 0) {
      addressError2 = secondaryAdvisor.addresses.map(address => {      
          if (
          !address.addresstype ||
          !address.city ||          
          !address.country ||
          !address.line1 ||
          typeof address.line1 === 'string' && address.line1.trim() === "" ||
          !address.state ||
          typeof address.state === 'string' && address.state.trim() === "" ||
          !address.zipcode ||
          typeof address.zipcode === 'string' && address.zipcode.trim() === ""
        )
          return true;
        else return false;
      });
    }
    
    if (secondaryAdvisor.phones && secondaryAdvisor.phones.length > 0) {
      phoneError2 = secondaryAdvisor.phones.map(phone => {
        if (checkPhone(phone)){
          return true;
        } else {
          if(phone.phonenumber.trim() === "" && phone.phonetype === "Primary"){
            return true;
          } else {
            return false;
          }
        } 
      });
    }

    if (secondaryErrors) {
      if (
        Object.prototype.hasOwnProperty.call(secondaryErrors, "city") &&
        Object.keys(secondaryErrors.city).length > 0
      ) {
        let cityError = secondaryErrors.city;
        for (let [key, value] of Object.entries(cityError))
          if (value != null) cityValError2 = true;
      }
      if (
        Object.prototype.hasOwnProperty.call(secondaryErrors, "state") &&
        Object.keys(secondaryErrors.state).length > 0
      ) {
        let stateError = secondaryErrors.state;
        for (let [key, value] of Object.entries(stateError))
          if (value != null) stateValError2 = true;
      }
      if (
        Object.prototype.hasOwnProperty.call(secondaryErrors, "zipcode") &&
        Object.keys(secondaryErrors.zipcode).length > 0
      ) {
        let zipcodeError = secondaryErrors.zipcode;
        for (let [key, value] of Object.entries(zipcodeError))
          if (value != null) zipcodeValError2 = true;
      }
    }
    if (
      secondaryAdvisor.firstname === "" ||
      secondaryAdvisor.lastname === "" ||
      secondaryAdvisor.dob === "" ||
      secondaryAdvisor.ssn === ""
    )
      secondaryUserFormError = true;
  }
  //Checking Primary advisor Error fields
  if (secondaryErrors) {
    if (
      Object.prototype.hasOwnProperty.call(secondaryErrors, "city") &&
      Object.keys(secondaryErrors.city).length > 0
    ) {
      let cityError = secondaryErrors.city;
      for (let [key, value] of Object.entries(cityError))
        if (value != null) cityValError2 = true;
    }
    if (
      Object.prototype.hasOwnProperty.call(secondaryErrors, "state") &&
      Object.keys(secondaryErrors.state).length > 0
    ) {
      let stateError = secondaryErrors.state;
      for (let [key, value] of Object.entries(stateError))
        if (value != null) stateValError2 = true;
    }
    if (
      Object.prototype.hasOwnProperty.call(secondaryErrors, "zipcode") &&
      Object.keys(secondaryErrors.zipcode).length > 0
    ) {
      let zipcodeError = secondaryErrors.zipcode;
      for (let [key, value] of Object.entries(zipcodeError))
        if (value != null) zipcodeValError2 = true;
    }
    if (
      Object.prototype.hasOwnProperty.call(secondaryErrors, "ssn") &&
      Object.keys(secondaryErrors.ssn).length > 0
    ) {
      let zipcodeError = secondaryErrors.ssn;
      for (let [key, value] of Object.entries(zipcodeError))
        if (value != null) ssnValError2 = true;
    }
    if (
      Object.prototype.hasOwnProperty.call(secondaryErrors, "confirmSSN") &&
      Object.keys(secondaryErrors.confirmSSN).length > 0
    ) {
      let zipcodeError = secondaryErrors.confirmSSN;
      for (let [key, value] of Object.entries(zipcodeError))
        if (value != null) cnfssnValError2 = true;
    }
  } 

  //Button enable/disable
  if (!secondaryActive) {
    if (
      relatedDonorError == false &&
      userform == false &&
      Array.isArray(emailError) && emailError.includes(true) === false &&
      Array.isArray(addressError) && addressError.includes(true) === false &&
      Array.isArray(phoneError) && phoneError.includes(true) === false &&
      Array.isArray(emailValError) && emailValError.includes(true) === false &&
      stateValError === false &&
      cityValError === false &&
      zipcodeValError === false
    ){
      return true;
    }else{
      return false;
    }
  } else {   
    if (
      relatedDonorError == false &&
      Array.isArray(emailError) && emailError.includes(true) === false &&
      Array.isArray(emailError2) && emailError2.includes(true) === false &&
      Array.isArray(addressError) && addressError.includes(true) === false &&
      Array.isArray(addressError2) && addressError2.includes(true) === false &&
      Array.isArray(phoneError) && phoneError.includes(true) === false &&
      Array.isArray(phoneError2) && phoneError2.includes(true) === false &&
      Array.isArray(emailValError) && emailValError.includes(true) === false &&
      stateValError === false &&
      cityValError === false &&
      zipcodeValError === false &&
      Array.isArray(emailValError2) && emailValError2.includes(true) === false &&
      stateValError2 === false &&
      cityValError2 === false &&
      zipcodeValError2 === false &&
      secondaryUserFormError === false &&
      ssnValError2 === false &&
      cnfssnValError2 === false
    )
      return true;
    else return false;
  }
}
